import "@/App.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/be-vietnam-pro/400.css";
import "@fontsource/be-vietnam-pro/500.css";
import "@fontsource/jetbrains-mono/400.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { GuildProvider } from "./contexts/GuildContext";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import DashboardHome from "./pages/DashboardHome";
import Tickets from "./pages/Tickets";
import TicketDetail from "./pages/TicketDetail";
import Staff from "./pages/Staff";
import Transcripts from "./pages/Transcripts";
import Settings from "./pages/Settings";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <GuildProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/dashboard" element={<Dashboard />}>
                  <Route index element={<DashboardHome />} />
                  <Route path="tickets" element={<Tickets />} />
                  <Route path="tickets/:ticketId" element={<TicketDetail />} />
                  <Route path="staff" element={<Staff />} />
                  <Route path="transcripts" element={<Transcripts />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster 
              position="top-right" 
              richColors 
              theme="system"
              toastOptions={{
                style: {
                  background: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  color: 'hsl(var(--foreground))'
                }
              }}
            />
          </div>
        </GuildProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
